module.exports = __webpack_public_path__ + "img/question-remove-btn.0bb6984e.svg";